var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_14831)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.414062 10.208C0.414062 8.25048 2.00096 6.66357 3.95851 6.66357C5.91605 6.66357 7.50295 8.25048 7.50295 10.208C7.50295 12.1656 5.91605 13.7525 3.95851 13.7525C2.00096 13.7525 0.414062 12.1656 0.414062 10.208Z",
    fill: "#A4344E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.498 3.95802C12.498 2.00048 14.0849 0.413574 16.0425 0.413574C18 0.413574 19.5869 2.00048 19.5869 3.95802C19.5869 5.91556 18 7.50246 16.0425 7.50246C14.0849 7.50246 12.498 5.91556 12.498 3.95802Z",
    fill: "#A4344E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.498 16.458C12.498 14.5005 14.0849 12.9136 16.0425 12.9136C18 12.9136 19.5869 14.5005 19.5869 16.458C19.5869 18.4156 18 20.0025 16.0425 20.0025C14.0849 20.0025 12.498 18.4156 12.498 16.458Z",
    fill: "#A4344E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4745 5.81246L6.89641 9.09891L6.52148 8.34847L13.0996 5.06201L13.4745 5.81246Z",
    fill: "#A4344E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89641 11.3173L13.4745 14.6037L13.0996 15.3542L6.52148 12.0677L6.89641 11.3173Z",
    fill: "#A4344E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_14831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.84cb40f14a455b14e9794c1c6f3ce91f.svg";
export { ForwardRef as ReactComponent };